import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SessionProvider } from './context/SessionContext';
import { SSOProvider } from './providers/SSOProvider';
import { LoginPage } from './components/Auth/LoginPage';
import { SignupPage } from './components/Auth/SignupPage';
import { SSOCallback } from './components/Auth/SSOCallback';
import { TokenHandler } from './components/TokenHandler';
import { ProtectedRoute } from './components/Auth/ProtectedRoute';
import Dashboard from './components/Dashboard/Dashboard'
import { LearnPage } from './components/Learn/LearnPage';
import { PracticePage } from './components/Learn/PracticePage';
import { TimedPracticePage } from './components/Learn/TimedPracticePage';
import ProgressAssessmentPage from './components/ProgressAssessment/ProgressAssessment';
import { AdminPage } from './components/Admin/admin';
import { AdminDownloadsPage } from './components/Admin/AdminDownloads';
import RosteringPage from './components/Admin/Rostering';
import { EarlyGradeMovePage } from './components/Admin/EarlyGradeMovePage';
import { CaliperMetrics } from './components/Admin/CaliperMetrics';
import { AssessmentResults } from './components/Admin/AssessmentResults';
import { ProgressDashboard } from './components/Admin/ProgressDashboard';
import { LearningSpeedDashboard } from './components/Admin/LearningSpeedDashboard';
import { LearningSpeedDashboard2 } from './components/Admin/LearningSpeedDashboard2';
import { AggregateTimeSpentDashboard } from './components/Admin/AggregateTimeSpentDashboard';
import { GradeMasteryReport } from './components/Admin/FastMathMasteryReport';
import { StudentCqpmDashboard } from './components/Admin/StudentCqpmDashboard';
import { AdminAlertsDashboard } from './components/Admin/AdminAlertsDashboard';
import { UnifiedStudentDashboard } from './components/Admin/UnifiedStudentDashboard';
import { AppPerformanceDashboard } from './components/Admin/AppPerformanceDashboard';
import QueryBuilderPage from './components/Admin/QueryBuilder/QueryBuilderPage';
import AccuracyPracticePage from './components/AccuracyPractice/AccuracyPracticePage';
import FluencyPracticePage from './components/FluencyPractice/FluencyPracticePage';
import PreKAssessment from './components/PreKAssessment/PreKAssessment';
import KAssessment from './components/KAssessment/KAssessment';
import PreKPracticePage from './components/PreKPractice/PreKPracticePage';
import KPracticePage from './components/KPractice/KPracticePage';
import KAccuracyAssessment from './components/KAccuracyAssessment/KAccuracyAssessment';
import { DocsPage } from './components/Docs/DocsPage';
import OnboardingAssessments from './components/OnboardingAssessments';
import StrategyLearningPage from './components/StrategyLearning/StrategyLearningPage';
import FluencyDrillPage from './components/FluencyDrill/FluencyDrillPage';
import { DatadogUserTracker } from './components/DatadogUserTracker';
// Import the progress queue service - this will initialize the queue on load
import './services/ProgressQueueService';

function App() {
    return (
        <Router>
            <SSOProvider>
                <AuthProvider>
                    <DatadogUserTracker>
                        <SessionProvider>
                            <TokenHandler>
                            <Routes>
                                <Route path="/" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <Dashboard />
                                    </ProtectedRoute>
                                } />
                                <Route path="/login" element={
                                    <ProtectedRoute requireAuth={false}>
                                        <LoginPage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/signup" element={
                                    <ProtectedRoute requireAuth={false}>
                                        <SignupPage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/auth/callback/cognito" element={<SSOCallback />} />
                                <Route path="/learn" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <LearnPage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/practice" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <PracticePage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/timedpractice" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <TimedPracticePage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/progress-assessment" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <ProgressAssessmentPage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/accuracy-practice" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <AccuracyPracticePage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/fluency-practice" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <FluencyPracticePage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/fluency-drill" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <FluencyDrillPage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/pre-k-assessment" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <PreKAssessment />
                                    </ProtectedRoute>
                                } />
                                <Route path="/k-assessment" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <KAssessment />
                                    </ProtectedRoute>
                                } />
                                <Route path="/pre-k-practice" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <PreKPracticePage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/k-practice" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <KPracticePage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/k-accuracy-assessment" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <KAccuracyAssessment />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <AdminPage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin/downloads" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <AdminDownloadsPage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin/rostering" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <RosteringPage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/early-grade-move" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <EarlyGradeMovePage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin/caliper" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <CaliperMetrics />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin/assessment-results" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <AssessmentResults />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin/progress" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <ProgressDashboard />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin/learning-speed" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <LearningSpeedDashboard />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin/learning-speed-v2" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <LearningSpeedDashboard2 />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin/aggregate-time-spent" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <AggregateTimeSpentDashboard />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin/grade-mastery" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <GradeMasteryReport />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin/student-cqpm" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <StudentCqpmDashboard />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin/alerts" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <AdminAlertsDashboard />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin/student-overview" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <UnifiedStudentDashboard />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin/app-performance" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <AppPerformanceDashboard />
                                    </ProtectedRoute>
                                } />
                                <Route path="/admin/query-builder" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <QueryBuilderPage />
                                    </ProtectedRoute>
                                } />
                                <Route path="/docs" element={<DocsPage />} />
                                <Route path="/onboarding" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <OnboardingAssessments />
                                    </ProtectedRoute>
                                } />
                                <Route path="/learning" element={
                                    <ProtectedRoute requireAuth={true}>
                                        <StrategyLearningPage />
                                    </ProtectedRoute>
                                } />
                            </Routes>
                        </TokenHandler>
                    </SessionProvider>
                </DatadogUserTracker>
            </AuthProvider>
        </SSOProvider>
        </Router>
    );
}

export default App;
